import { useEffect, useState } from "react";
import { UploadSimple, X } from "@phosphor-icons/react";
import api from "@/lib/api";

let dismissedThisSession = false;

export default function ImportNoticeBanner() {
  const [notices, setNotices] = useState([]);
  useEffect(() => {
    if (dismissedThisSession) return;
    api.get("/me/import-notices").then((r) => { if (!dismissedThisSession) setNotices(r.data.notices || []); }).catch(() => {});
  }, []);
  if (!notices.length) return null;
  const n = notices.length;
  const labels = [...new Set(notices.map((x) => x.source_label).filter(Boolean))];
  const what = labels.length === 1 ? `${labels[0]} import${n === 1 ? "" : "s"}` : `import${n === 1 ? "" : "s"}`;
  const dismiss = () => { dismissedThisSession = true; setNotices([]); api.post("/me/import-notices/dismiss").catch(() => {}); };
  return (
    <div className="mb-8 max-w-3xl rounded-2xl border border-rf-orange/30 bg-rf-amber/15 p-5 flex gap-4 items-start" data-testid="import-notice-banner">
      <div className="w-11 h-11 rounded-full bg-rf-orange text-white flex items-center justify-center shrink-0"><UploadSimple size={20} weight="bold" /></div>
      <div className="flex-1 min-w-0">
        <p className="font-display font-black text-lg text-rf-ink" data-testid="import-notice-title">
          {n === 1 ? `One of your ${what} didn't finish` : `${n === 2 ? "Two" : n} of your ${what} didn't finish`}
        </p>
        <p className="text-sm text-rf-ink-soft mt-1 mb-3">
          Sorry about that. We couldn't keep the file{n === 1 ? "" : "s"}, so please upload {n === 1 ? "it" : "them"} again.
          We've made big imports much more reliable, so {n === 1 ? "it" : "they"} should go straight through this time.
        </p>
        <a href="/import" data-testid="import-notice-upload-btn" className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-rf-orange text-white text-sm font-bold hover:bg-rf-orange/90 transition-colors">
          <UploadSimple size={16} /> Upload again
        </a>
      </div>
      <button type="button" onClick={dismiss} aria-label="Dismiss" data-testid="import-notice-dismiss-btn" className="w-8 h-8 rounded-full hover:bg-white/60 flex items-center justify-center text-rf-ink-soft"><X size={16} /></button>
    </div>
  );
}
